import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FileRemoveEvent,
  FileUpload,
  FileUploadHandlerEvent,
  FileUploadModule,
} from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { ButtonIconAtomComponent } from '../button-icon-atom/button-icon-atom.component';

@Component({
  selector: 'ls-single-upload-file-atom',
  standalone: true,
  imports: [CommonModule, FileUploadModule, ImageModule, ButtonIconAtomComponent],
  templateUrl: './single-upload-file-atom.component.html',
  styleUrl: './single-upload-file-atom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SingleUploadFileAtomComponent {
  @Input() maxFileSize = 1000000;
  @Input() previewWidth = 150;

  @Output() onSelect: EventEmitter<File> = new EventEmitter();
  @Output() onRemove: EventEmitter<File> = new EventEmitter();

  @ViewChild('fileUpload', { static: true }) fileUpload!: FileUpload;

  get files(): File[] {
    return this.fileUpload.files;
  }
  set files(value: File[]) {
    this.fileUpload.files = value;
    this.fileUpload.cd.detectChanges();
  }

  handleSelect(event: FileUploadHandlerEvent) {
    this.onSelect.emit(event.files[0]);
  }

  handleRemove(event: FileRemoveEvent) {
    this.onRemove.emit(event.file);
  }

  detectChanges() {
    this.fileUpload?.cd.detectChanges();
  }
}
